import React, { useState } from 'react';
import exportService from '../services/exportService';

interface InventoryExportButtonProps {
  onExportStart?: () => void;
  onExportComplete?: (filename: string) => void;
  onExportError?: (error: string) => void;
  disabled?: boolean;
  className?: string;
  showProgress?: boolean;
}

const InventoryExportButton: React.FC<InventoryExportButtonProps> = ({
  onExportStart,
  onExportComplete,
  onExportError,
  disabled = false,
  className = 'btn btn-secondary',
  showProgress = false
}) => {
  const [isExporting, setIsExporting] = useState(false);
  const [progress, setProgress] = useState(0);

  const handleExport = async () => {
    if (isExporting || disabled) return;

    setIsExporting(true);
    setProgress(0);
    onExportStart?.();

    try {
      const filename = await exportService.exportAndDownload({
        timeout: 60000,
        onProgress: showProgress ? setProgress : undefined
      });

      onExportComplete?.(filename);
    } catch (error: any) {
      console.error('Export failed:', error);
      onExportError?.(error.message || 'Export failed. Please try again.');
    } finally {
      setIsExporting(false);
      setProgress(0);
    }
  };

  return (
    <button
      className={className}
      onClick={handleExport}
      disabled={isExporting || disabled}
      title={isExporting ? 'Exporting inventory data...' : 'Export inventory to Excel file'}
    >
      <span className="btn-icon">
        {isExporting ? '⏳' : '📊'}
      </span>
      {isExporting ? (
        showProgress ? `Exporting... ${progress}%` : 'Exporting...'
      ) : (
        'Export to Excel'
      )}
    </button>
  );
};

export default InventoryExportButton;